import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const serviceURL = `${environment.api}/projects`;

@Injectable({
  providedIn: 'root'
})
export class TeamsService {
  constructor(private http: HttpClient) {}

  getTeams(
    year?: any,
    start_sprint_number?: any,
    end_sprint_number?: any,
    project_ids: number[] = []
  ) {
    let params = {
      year: year,
      start_sprint_number: start_sprint_number,
      end_sprint_number: end_sprint_number,
      project_ids: project_ids
    };
    return this.http.post<any>(serviceURL + '/myTeams', params);
  }

  getProjectsSelect(search: string) {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    return this.http.get<any>(serviceURL + '/getProjectsSelect', {
      params: new HttpParams().set('search', search),
      context: new HttpContext().set(CONFIG, config)
    });
  }

  // getAspirations(): Observable<Response<any>> {
  //   return this.http.get<Response<any>>(this.serviceURL+'/getEmployeeAspiration');
  // }
}
